import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Debug"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.3724 15L22.6274 13.5L18.7499 12.8625V9.5775L22.5449 8.5575L22.1624 7.11L18.5399 8.0775C18.0408 6.19114 16.7499 4.61303 14.9999 3.75V1.5H13.4999V3.1725C12.5131 2.94248 11.4867 2.94248 10.4999 3.1725V1.5H8.99988V3.75C7.24434 4.62293 5.95508 6.21602 5.46738 8.115L1.84488 7.11L1.49988 8.5575L5.24988 9.5775V12.8625L1.37988 13.5L1.61988 15L5.24988 14.385C5.26702 15.3105 5.47645 16.2223 5.86488 17.0625L2.46738 20.4675L3.53238 21.5325L6.67488 18.3825C7.95385 20.0243 9.91868 20.9844 11.9999 20.9844C14.0811 20.9844 16.0459 20.0243 17.3249 18.3825L20.4674 21.5325L21.5324 20.4675L18.1274 17.0625C18.5184 16.2229 18.7304 15.311 18.7499 14.385L22.3724 15ZM11.2498 19.44C8.66915 19.0675 6.7529 16.8574 6.74984 14.25V9.75H11.2498V19.44ZM6.96733 8.25002C7.62919 6.02277 9.67633 4.49549 11.9998 4.49549C14.3233 4.49549 16.3705 6.02277 17.0323 8.25002H6.96733ZM17.2498 14.25C17.2468 16.8574 15.3305 19.0675 12.7498 19.44V9.75H17.2498V14.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Debug.vue"]]);
